<template>
  <div class="rateComp">
    <a class="btn  btn-mode btn-rate btn-tip" @click.stop="rateStatus = true">
      <i class="icon">{{ getRate}}</i>
      <span>语速</span>
    </a>
    <div class="el-dialog__wrapper" v-show="rateStatus" @click="rateStatus = false">
      <div class="srWrap" @click.stop>
        <div class="srHead flexBw">语速控制 <span class="iconfont xiala1" @click.stop="rateStatus = false"></span></div>
        <div class="srTitle flex-center">语速 {{ getRate }}</div>
        <div class="srList flexBw">
          <div class="srItem flex-center" v-for="(item, idx) in pickerList" :key="item" :class="getGlobalAudioRate === +item && 'on'"
            @click="onRate(idx)">
            <span class="srLine"></span>
            {{ item }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      pickerList: Object.freeze(['0.5', '0.75', '1.0', '1.25', '1.5', '2.0']),
      rateStatus: false
    }
  },
  computed: {
    ...mapGetters(["getGlobalAudioRate"]),
    getRate() {
      return `x${Number.isInteger(this.getGlobalAudioRate) ? this.getGlobalAudioRate.toFixed(1) : this.getGlobalAudioRate}`;
    }
  },
  methods: {
    onRate(val) {
      const rate = +this.pickerList[+val];
      this.$store.commit("setGlobalAudioRate", rate);
      // this.rateStatus = false;
    }
  }
}

</script>

<style lang="less" scoped>
.btn-rate {
  margin-left: 20px;

  i {
    line-height: 22px;
  }
}

.el-dialog__wrapper {
  z-index: 3;
}

.srWrap {
  width: 375px;
  height: 227px;
  background: #FFFFFF;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  position: absolute;
  bottom: 100px;
  left: 52%;
  cursor: pointer;
  color: #333333;

  .srHead {
    font-size: 16px;
    font-weight: bold;
    padding: 24px 20px;
    .iconfont {
      font-weight: normal;
      font-size: 24px;
      color: #999;
    }
  }

  .srTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .srList {
    font-size: 12px;
    color: #666666;
    margin: 24px 15px 0;
    position: relative;

    &::before {
      content: '';
      width: 100%;
      height: 40px;
      background: #F4F4F4;
      border-radius: 22px;
      position: absolute;
      top: 0;
      // z-index: -1;
    }

    .srItem {
      padding: 0 12px;
      position: relative;
      flex-direction: column;

      &.on::after {
        content: '';
        display: inline-block;
        width: 40px;
        height: 40px;
        background: #FFFFFF;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16), 0px 0px 8px 2px rgba(0, 0, 0, 0.06);
        border-radius: 50%;
        position: absolute;
        top: 0;
        left: 1px;
      }
    }

    .srLine {
      width: 1px;
      height: 16px;
      background: #DDDDDD;
      border: 12px solid #F4F4F4;
      // border-bottom: 24rpx solid #F4F4F4;
      border-width: 12px 4px;
      display: inline-block;
      margin-bottom: 16px;
      box-sizing: content-box;

    }
  }
}
</style>